import { render, staticRenderFns } from "./Summaries.vue?vue&type=template&id=00891b43&scoped=true"
import script from "./Summaries.vue?vue&type=script&lang=js"
export * from "./Summaries.vue?vue&type=script&lang=js"
import style0 from "./Summaries.vue?vue&type=style&index=0&id=00891b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00891b43",
  null
  
)

export default component.exports